import script from "./ProductDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetail.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetail.vue?vue&type=style&index=0&id=73d5c75c&scoped=true&lang=css"
import "./ProductDetail.vue?vue&type=style&index=1&id=73d5c75c&scoped=true&lang=css"
import "./ProductDetail.vue?vue&type=style&index=2&id=73d5c75c&scoped=true&lang=css"
import "./ProductDetail.vue?vue&type=style&index=3&id=73d5c75c&scoped=true&lang=css"
import "./ProductDetail.vue?vue&type=style&index=4&id=73d5c75c&scoped=true&lang=css"
import "./ProductDetail.vue?vue&type=style&index=5&id=73d5c75c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73d5c75c"]])

export default __exports__